import {
    ColumnGap,
    FilterClearButton,
    FilterContainer,
    FlexDirectionWrapper,
    MainContent,
    SubTitle,
    Text,
    WrapperLegend
} from "../../../../../components/StyledComponents";
import React, { useEffect, useState } from "react";
import { ManutencaoService } from "../../../services/manutencaoService";
import { handleModalAdmin } from "../../../../../utils/handleModalAdmin";
import { TableAdmin } from "../../../../../components/TableAdmin";
import FiltersModel from "../../../filters.model";
import { useApp } from "../../../../../context/app";
import { SearchInputAdmin } from "../../../../../components/SearchInputAdmin";
import { FaRegCheckCircle } from "react-icons/fa";
import { removeEmpty } from "../../../../../utils/utils";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { BaSeIcon } from "@base/react";

const opcoesServicos = {
    'NA_PALMA_DA_MAO': 'App Sebrae',
    'NA_PALMA_ADM': 'Admin'
}

const tableColumns = [
    {
        field: "dataCriacao",
        id: "dataCriacao",
        label: "Data",
        minWidth: 10
    },
    {
        field: "criadoPor",
        id: "criadoPor",
        label: "Responsável",
        align: "left",
        handleField: (criadoPor) => criadoPor?.nome,
        minWidth: 10
    },
    {
        field: "servico",
        id: "servico",
        label: "Serviço",
        handleField: (servico) => opcoesServicos[servico],
        align: "left",
    },
    {
        field: "diario",
        id: "diario",
        label: "Diário",
        handleField: (diario) => diario ? 'Sim' : 'Não',
        align: "left",
    },

    {
        field: "motivo",
        id: "motivo",
        label: "Motivo",
        align: "left",
    },
    {
        field: "descricao",
        id: "descricao",
        label: "Descrição",
        align: "left",
        columnStyle: {
            overflowWrap: 'break-word',
            width: 300,
            wordBreak: 'break-word',
            whiteSpace: 'break-spaces'
        },
    },
    {
        field: "horaInicio",
        id: "horaInicio",
        label: "Hora Início",
        align: "left",
    },
    {
        field: "horaFim",
        id: "horaFim",
        label: "Hora Fim",
        align: "left",
    },
    {
        field: "actions",
        id: "actions",
        label: "Status",
        minWidth: 150,
        align: 'left',
    },
];

export const Gerenciar = () => {
    const {setRenderIncludeScreen, setManageItem} = useApp();
    const [data, setData] = useState([]);
    const {setMaintenanceMode} = useApp();

    const {
        inputSearchValue,
        setInputSearchValue,
        filters,
        setFilters,
        paginationFilters,
        setPaginationFilters,
        handleOrderClick,
        onLinesPerPageChange,
        handlePageChange,
        handleInputPageChange,
        isLoading,
        setIsLoading,
        showModal
    } = FiltersModel()


    const getBodyParams = () => {
        return removeEmpty({...filters, oqueVoceProcura: inputSearchValue});
    };

    const getLastMaintenanceAdmin = async () => {
        const data = await ManutencaoService.manutencaoAdmin();
        setMaintenanceMode(!!data);
    }

    const getData = async () => {
        try {
            const bodyParams = getBodyParams();
            const response = await ManutencaoService.findAll(
                paginationFilters,
                bodyParams
            );
            setData(response);
        } catch (e) {
            console.log('erro =>>', e);
        } finally {
            setIsLoading(false);
        }
    };

    const changeState = async (item) => {
        return await ManutencaoService.changeStatus(item.id);
    };

    const handleStateClick = (item) => {

        const modalInfo = item.manutencao ?
            {
                title: 'Desaprovar manutenção',
                content: <span>Ao <span style={{fontWeight: 'bold'}}>DESAPROVAR</span> o App sairá da manutenção e habilitará acesso ao usuário. Deseja continuar?`</span>,
                msgOnSuccess: `A manutenção foi desaprovada com sucesso!`,
                msgOnError: `A manutenção não foi desaprovada. <br> Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`
            } : {
                title: 'Aprovar manutenção',
                content: <span>Ao <span style={{fontWeight: 'bold'}}>APROVAR</span> o App ficará em manutenção sem acesso do usuário. Deseja continuar?</span>,
                msgOnSuccess: `A manutenção foi aprovada com sucesso!`,
                msgOnError: `A manutenção não foi aprovada. <br> Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`
            }

        const {title, content, msgOnSuccess, msgOnError} = modalInfo;

        handleModalAdmin({
            title,
            content,
            msgOnSuccess,
            msgOnError,
            onConfirmClick: () => changeState(item),
            onFinish: () => {
                setIsLoading(true);
                setData([]);
                getData();
                getLastMaintenanceAdmin()
            },
            showModal: showModal,
        });
    };

    const handleDeleteClick = (id) => {
        handleModalAdmin({
            title: `Excluir`,
            content: `Ao EXCLUIR esta manutenção programada será excluída da base. Deseja continuar?`,
            msgOnSuccess: `A manutenção foi excluída com sucesso!`,
            msgOnError: `A manutenção não foi excluída. <br/>Aconteceu um erro ou o sistema está temporariamente fora do ar. Tente novamente mais tarde.`,
            onFinish: () => {
                setIsLoading(true);
                setData([]);
                getData();
                getLastMaintenanceAdmin()
            },
            onConfirmClick: async () => await ManutencaoService.delete(id),
            showModal: showModal,
        });
    };

    const handleEditClick = (item) => {
        setManageItem({
            type: 'edit',
            data: item,
        });
        setRenderIncludeScreen(true);
    };


    const handleFilterByStatus = (value) => {
        if (value === filters?.manutencao) {
            setFilters((f) => ({...f, manutencao: null}));
            return;
        }
        setFilters((f) => ({...f, manutencao: value}));
        setPaginationFilters({
            ...paginationFilters,
            page: 0,
        });
    };

    const handleClearFilters = () => {
        setInputSearchValue(null);
        setFilters({
            manutencao: null
        });
        setData([])
    }

    useEffect(() => {
        getData()
        // https://github.com/facebook/create-react-app/issues/6880
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [paginationFilters, filters, inputSearchValue]);

    return (
        <MainContent>
            <SubTitle>
                <>
                    <h3>Gerenciar</h3>
                    <SearchInputAdmin
                        value={inputSearchValue}
                        onChange={setInputSearchValue}
                    />
                </>
            </SubTitle>

            <FilterContainer>
                <Accordion style={{ backgroundColor: '#F8F8F8', marginBottom: 20 }}>
                    <AccordionSummary
                        expandIcon={<ExpandMoreIcon />}
                        aria-controls="accordion-filter"
                        id="accordion-filter"
                    >
                        <BaSeIcon
                            name="filter"
                            color={'#B3B3B3'}
                            size={25}
                            description="Ícone de filtro"
                        />
                        <p style={{ color: '#B3B3B3', fontWeight: 'bold' }}>Filtrar</p>
                        <FilterClearButton
                            color={'#B3B3B3'}
                            onClick={(e) => {
                                e.stopPropagation();
                                handleClearFilters()
                            }}
                        >
                            <BaSeIcon
                                name="close"
                                size={10}
                                color={'#B3B3B3'}
                                description="Limpar filtros"
                            />
                            <p
                                style={{
                                    fontSize: '12px',
                                    color: '#B3B3B3',
                                    borderBottom: `1px solid ${'#B3B3B3'}`,
                                }}
                            >
                                Limpar filtros
                            </p>
                        </FilterClearButton>
                    </AccordionSummary>
                </Accordion>
            </FilterContainer>

            <WrapperLegend>
                <ColumnGap
                    gap="7px"
                    padding="6px 10px"
                >

                </ColumnGap>

                <ColumnGap gap="17px">
                    <ColumnGap
                        align="center"
                        gap="8px"
                        onClick={() => handleFilterByStatus(true)}
                    >
                        <FaRegCheckCircle size={25} color="#0061C6"/>
                        <Text
                            color={
                                filters.manutencao ? 'black' : '#B3B3B3'
                            }
                        >
                            Aprovado
                        </Text>
                    </ColumnGap>
                    <ColumnGap
                        align="center"
                        gap="8px"
                        onClick={() => handleFilterByStatus(false)}
                    >
                        <FaRegCheckCircle size={25} color="#FF0000"/>
                        <Text
                            color={
                                filters.manutencao === false ? 'black' : '#B3B3B3'
                            }
                        >
                            Aguardando aprovação
                        </Text>
                    </ColumnGap>
                </ColumnGap>
            </WrapperLegend>

            <FlexDirectionWrapper
                style={{ justifyContent: 'space-between', marginTop: '12px' }}
            >
                <ColumnGap gap="4px">
                    <Text color="#0061C6" weight="bold">
                        {data?.totalElements ?? 0}
                    </Text>
                    <Text color="#B3B3B3">
                        {data?.totalElements === 1 ? 'resultado' : 'resultados'} encontrados
                    </Text>
                </ColumnGap>
            </FlexDirectionWrapper>

            <TableAdmin
                {...{
                    data,
                    paginationFilters,
                    isLoading,
                    onLinesPerPageChange,
                    handleDeleteClick,
                    handleEditClick,
                    handleOrderClick,
                    handleStateClick,
                }}
                sentEntireObjectToEdit
                sentEntireObjectToCopy
                columnAction={"actions"}
                propertyColumnStatus={"manutencao"}
                linesPerPageFilters={paginationFilters?.linesPerPage}
                pagination={true}
                totalPages={data?.totalPages}
                columns={tableColumns}
                tableColor={"#0061C6"}
                lineColor={"rgba(0, 97, 198, 0.1)"}
                onPagePreviousChange={handlePageChange}
                onPageNextChange={handlePageChange}
                onInputPageChange={handleInputPageChange}
            />
        </MainContent>
    );
}
